import { render, staticRenderFns } from "./text-response.vue?vue&type=template&id=057095c1&scoped=true&"
import script from "./text-response.vue?vue&type=script&lang=js&"
export * from "./text-response.vue?vue&type=script&lang=js&"
import style0 from "./text-response.vue?vue&type=style&index=0&id=057095c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057095c1",
  null
  
)

component.options.__file = "text-response.vue"
export default component.exports